import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './Failed.scss';

// Temporary loading component
export function Failed({ ratio = 1 }: { ratio: number }) {
	useStyles(s);
	return (
		<div
			className="image__failed-state"
			style={{ aspectRatio: `${ratio}` }}
		>
			Check your internet connection
		</div>
	);
}
